export const beOurPartnerUrl = 'https://parceiro.medprev.online/seja-nosso-parceiro/';

export const partnerUrl = 'https://parceiro.medprev.online/';

export const partnerSacEmail = 'mailto:parceiros@medprevonline.com';
